import React, { useContext } from 'react';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Container } from '@comparethemarketau/manor-grid';

import { ComparisonTitle } from './common/comparison_title';
import { ComparisonSubTitle } from './common/comparison_sub_title';
import { ComparisonProducts } from './widget/comparison_products';
import { BackToResultsButton } from './common/back_to_results_button';

const useStyles = createUseStyles((theme) => ({
    title: {
        fontSize: theme.fontSize['4xl']
    },
    subTitle: {
        fontSize: theme.fontSize.base,
        marginTop: '2rem'
    },
    products: {
        marginTop: '5.6rem'
    },
    backButtonTop: {
        marginLeft: '1rem'
    },
    backButtonBottom: {
        marginTop: '4.8rem',
        width: '35.8rem',
        alignSelf: 'center'
    }
}));

const PolicyComparisonSm = () => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    return (
        <Container padding={['92', '40', '32', '40']} className={classNames('test-policyComparison-sm')}>
            <BackToResultsButton variant="tertiary" className={classes.backButtonTop} />
            <ComparisonTitle className={classes.title} />
            <ComparisonSubTitle className={classes.subTitle} />
            <ComparisonProducts className={classes.products} />
            <BackToResultsButton label="Back to all results" variant="primary" className={classes.backButtonBottom} />
        </Container>
    );
};

export { PolicyComparisonSm };
